import React from 'react';
import { useGame } from 'context/GameContext';
import Tooltip from './Tooltip';
import * as Styled from './Notifications.style';

function Notifications() {
  const { gameState } = useGame();
  const { notifications } = gameState;

  return (
    <Styled.NotificationsContainer>
      {notifications &&
        notifications
          .filter((n, i) => i === 0 || n !== notifications[i - 1])
          .map((n, i) => {
            if (typeof n === 'object') {
              if (n.isDialog) {
                return <Styled.Dialog key={i}>{n.label}</Styled.Dialog>;
              } else if (n.isEvent) {
                return (
                  <Styled.EventContainer key={i}>
                    <Styled.Event key={i}>{n.label}</Styled.Event>
                    {n.tooltip && (
                      <Styled.TooltipContainer>
                        <Tooltip entries={n.tooltip} />
                      </Styled.TooltipContainer>
                    )}
                  </Styled.EventContainer>
                );
              }
              console.warn('Notification is not a dialog or event');
              return <Styled.Notification key={i}>{n.label}</Styled.Notification>;
            }
            return <Styled.Notification key={i}>{n}</Styled.Notification>;
          })}
    </Styled.NotificationsContainer>
  );
}

export default Notifications;
